import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { usePlatformStore, useInvitation } from "@platform/store";
import { SignupFormContainer } from "@platform/features/auth";
import { Type } from "@themes/pollinator/ui/Type";
import { TwoPanelLayout } from "@themes/pollinator/ui/TwoPanelLayout";
import { getOnboardingPathFromInvitation } from "@core/features/onboarding";

export function InvitationSignupPage() {
  const navigate = useNavigate();

  const setUser = usePlatformStore((s) => s.setUser);
  const clearAuth = usePlatformStore((s) => s.clearAuth);

  const queryClient = useQueryClient();
  const { invitation, claimedVia } = useInvitation();

  const handleSuccessfulSignup = (data: any) => {
    queryClient.clear();

    setUser(data.userData, data.authToken);

    const programId = data.program_id;
    if (programId) {
      navigate(
        getOnboardingPathFromInvitation({
          invitationType: data.invitation_type,
          organizationId: data.organization_id,
          programId,
        })
      );
    } else {
      navigate("/dashboard");
    }
  };

  const handleError = () => {
    clearAuth();
  };

  // invitation is guaranteed by InvitationLayout
  if (!invitation) return null;

  return (
    <TwoPanelLayout
      testId="invitation-signup-layout"
      leftPanel={
        <div className="flex flex-col flex-1 justify-center px-8 border-b border-brand-800 md:px-12 py-6 md:py-8 max-w-[640px]">
          <div className="flex flex-col gap-6">
            <Type variant="h1" as="h1" className="text-brand-800 md:text-brand-50">
              Create Your Account
            </Type>
            <Type variant="body1" as="p" className="text-brand-800 md:text-brand-200">
              Join {invitation.program_name}
            </Type>
          </div>
        </div>
      }
      rightPanel={
        <div className="flex-1 flex flex-col justify-between">
          <SignupFormContainer
            invitation={invitation}
            claimedVia={claimedVia}
            onError={handleError}
            onSuccess={handleSuccessfulSignup}
          />
        </div>
      }
    />
  );
}

export default InvitationSignupPage;


